module.exports = __webpack_public_path__ + "img/zanwu1.c4842732.png";